<template>
    <div class="border-b border-a-brown-e1d2bc text-16 font-bold flex justify-center">
        <div class="splide" id="cate-reward">
            <div class="splide__track">
                <ul ref="test" class="splide__list">
                    <li class="splide__slide"
                        v-for="(cat, k) in catList"
                        :key="k">
                        <div v-show="k == activeIndex" class="w-full flex flex-col md:flex-row md:justify-center items-center border-b-4 border-a-red-d62300 p-1">
                            <div class="mb-1 md:mb-0">
                                <img v-if="cat.mode == 'subscription'" class="h-7 md:h-8" src="@/assets/icon/ic-subscription-menu-active.png" alt="">
                                <img v-else class="h-7 md:h-8" :src="cat.imageActive">
                            </div>
                            <div class="text-a-red-d62300 text-center break-words">{{catName(cat)}}</div>
                        </div>
                        <div v-show="k != activeIndex"  class="w-full flex flex-col md:flex-row md:justify-center items-center border-b-4 border-a-egg-f5ebdc p-1" @click="clickTab(k)">
                            <div class="mb-1 md:mb-0">
                                <img v-if="cat.mode == 'subscription'" class="h-7 md:h-8" src="@/assets/icon/ic-subscription-menu-inactive.png" alt="">
                                <img v-else class="h-7 md:h-8" :src="cat.imageInactive">
                            </div>
                            <div class="text-a-brown-502314 text-center break-words">{{catName(cat)}}</div>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>
<script>
import Splide from '@splidejs/splide'; //https://splidejs.com/
import Util from '@/helper/Utility.js';
import LocaleMixin from '@/mixin/LocaleMixin.js';

export default {
    name: 'CatSlider',
    mixins: [LocaleMixin],
    props: {
        catList: { type: Array, required: true },
        subscriptMode: { type: Boolean, default: false },
    },
    data: function() {
        return {
            activeIndex: 0,
            slide: {
                isDown: false,
                startX: 0,
                scrollLeft: 0,
            },
            slider: null,
        };
    },
    created: function() {
        this.setDefaultTab();
        this.initSlider();
    },
    methods: {
        initSlider: function () {
            this.$nextTick(() => {
                let currentIndex = this.activeIndex;
                this.slider = new Splide('#cate-reward', {
                    arrows: false,
                    pagination: false,
                    autoWidth: true,
                    gap: 25,
                    padding: 0,
                    start: currentIndex,
                    breakpoints: {
                        1024: {
                            padding: 16,
                        },
                    },
                }).mount();
            });
        },
        // getCurrentIndex: function () {
        //     let found = 0;
        //     for (let i in this.cateList) {
        //         if (this.cateList[i].id == this.activeCateId) {
        //             found = i;
        //             break;
        //         }
        //     }
        //     return found;
        // },
        setDefaultTab: function() {
            let catId = this.$route.params.catId;

            if (!Util.isEmptyStr(catId)) {
                for (let i in this.catList) {
                    if (this.catList[i].id == catId) {
                        this.activeIndex = i;
                        break;
                    }
                }
            }
        },
        // setActiveIndex: function () {
        //     if (this.selectedCat != null) {
        //         this.activeCateId = this.selectedCat.id;
        //     } else {
        //         this.activeCateId = null;
        //     }
        // },
        catName: function(cat) {
            return this.localeCode == 1033 ? cat.nameEn : cat.nameTh;
        },
        clickTab: function(index) {
            this.activeIndex = index;
            let send = {
                index: index,
                cat: this.catList[index],
            };
            this.$emit('clickTab', send);
        },
    },
}
</script>
<style lang="scss">

#cate-reward {
    //set item center
    .splide:not( .is-overflow ) .splide__list {
        justify-content: center;
    }

    .splide__track {
        max-width: 100vw;
    }
}
</style>
